import { render, staticRenderFns } from "./MicrosoftCallback.vue?vue&type=template&id=772a5194&"
import script from "./MicrosoftCallback.vue?vue&type=script&lang=js&"
export * from "./MicrosoftCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports